<template>
  <div class="option_payment_setting">
    <PaymentAdArea v-if="adShow"/>
    <ServiceInformation
        v-if="infoShow"
        @getMyPurchaseSummaryFromServer="getMyPurchaseSummaryFromServer"
        :paymentInfoProps="paymentInfo"
        :currentSubscriptionInfoProps="currentSubscriptionInfo"
        :nextSubscriptionInfoProps="nextSubscriptionInfo"
    />
    <DetailsOfUsage
        v-show="totalPurchaseCount > 0"
        :totalPurchaseCountProps="totalPurchaseCount"/>
  </div>
</template>
<script>
import _API from '@/api';
import ServiceInformation from './serviceInformation';
import DetailsOfUsage from './detailsOfUsage';
import PaymentAdArea from "./paymentAdArea";

export default {
  name: 'PaymentSetting',
  components: {
    PaymentAdArea,
    ServiceInformation,
    DetailsOfUsage
  },
  data() {
    return {
      adShow: false,
      infoShow: false,
      paymentInfo: {},
      currentSubscriptionInfo: {},
      nextSubscriptionInfo: {},
      totalPurchaseCount: 0
    }
  },
  created() {
    this.getMyPurchaseSummaryFromServer();
  },
  methods: {
    getMyPurchaseSummaryFromServer() {
      _API.PAYMENT.getMyPurchaseSummary()
          .then(({data}) => {
            if (data.isSuccess) {
              this.paymentInfo = data.paymentInfo;
              this.currentSubscriptionInfo = data.currentSubscriptionInfo;
              this.nextSubscriptionInfo = data.nextSubscriptionInfo;
              this.totalPurchaseCount = data.totalPurchaseCount;

              this.adShow = Object.keys(this.currentSubscriptionInfo).length === 0;
              this.infoShow = Object.keys(this.currentSubscriptionInfo).length > 0;
            } else {
              /** failedCode =
               * MA2000 : 매니져가 아니거나 잘못된 매니저 상태
               * PAY2000 : 결제서버 알 수 없는 오류
               */
              this.$modal.show('common-alert-modal', {
                messageType: 'short',
                message: 'alert.unexpected_error'
              });
            }
          })
    }
  }
}
</script>
<style lang="scss">
.option_payment_setting {
  .option_my_service {
    display: flex;
    align-items: center;

  }
}
</style>